import React from 'react'
import PropTypes from 'prop-types'
import uniqueId from 'lodash/uniqueId'
import Svg from '../../Svg'

const genId = () => uniqueId('extraPrincipalTeaser')
const a = genId()
const b = genId()
const c = genId()
const d = genId()

const propTypes = {
  className: PropTypes.string,
}

const ExtraPrincipalTeaserScreen = ({ className, ...restProps }) => (
  <Svg viewBox='0 0 486 405' className={className} {...restProps}>
    <defs>
      <path id={b} d='M0 0h450v369H0z' />
      <filter
        id={a}
        width='112.4%'
        height='115.2%'
        x='-6.2%'
        y='-7%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='9'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0'
        />
      </filter>
      <text
        id={d}
        fill='var(--brand-success-700)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='36'
        fontWeight='300'
        letterSpacing='-1.2'
      >
        <tspan x='165.086' y='200'>
          $50,19
        </tspan>{' '}
        <tspan x='268.365' y='200'>
          7
        </tspan>
      </text>
      <filter
        id={c}
        width='111.3%'
        height='128.6%'
        x='-5.6%'
        y='-10.2%'
        filterUnits='objectBoundingBox'
      >
        <feOffset dy='2' in='SourceAlpha' result='shadowOffsetOuter1' />
        <feGaussianBlur
          in='shadowOffsetOuter1'
          result='shadowBlurOuter1'
          stdDeviation='2'
        />
        <feColorMatrix
          in='shadowBlurOuter1'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
        />
      </filter>
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(18 16)'>
        <use
          fill='var(--brand-hb-black)'
          filter={`url(#${a})`}
          href={`#${b}`}
        />
        <use fill='var(--brand-surface-elevation-300)' href={`#${b}`} />
      </g>
      <text
        fontFamily='OpenSans-Regular, Open Sans'
        fontSize='14'
        transform='translate(18 16)'
      >
        <tspan x='61.637' y='235' fill='var(--brand-neutral-cool-700)'>
          in interest over the rest of your loan. You’d also be{' '}
        </tspan>{' '}
        <tspan x='56.192' y='256' fill='var(--brand-neutral-cool-700)'>
          done with the loan and no longer making payments{' '}
        </tspan>{' '}
        <tspan x='176.443' y='277' fill='var(--brand-success-700)'>
          6 years earlier
        </tspan>{' '}
        <tspan x='268.817' y='277' fill='var(--brand-neutral-cool-900)'>
          !
        </tspan>
      </text>
      <g fill='var(--brand-success-700)' transform='translate(18 16)'>
        <use filter={`url(#${c})`} href={`#${d}`} />
        <use href={`#${d}`} />
      </g>
      <g transform='translate(253 101)'>
        <rect
          width='113'
          height='37'
          fill='var(--brand-hb-white)'
          fillOpacity='.05'
          rx='5'
        />
        <text
          fill='var(--brand-primary-600)'
          fontFamily='OpenSans-Regular, Open Sans'
          fontSize='24'
        >
          <tspan x='8.055' y='27'>
            $200
          </tspan>
        </text>
        <path fill='var(--brand-primary-600)' d='M93.5 14.5H108l-7.25 9z' />
      </g>
      <text
        fill='var(--brand-neutral-cool-900)'
        fontFamily='OpenSans-Light, Open Sans'
        fontSize='24'
        fontWeight='300'
        transform='translate(18 16)'
      >
        <tspan x='37.404' y='110'>
          Tip: If you pay just
        </tspan>
        <tspan x='352' y='110'>
          more
        </tspan>
        <tspan x='74.605' y='146'>
          each month, you could save
        </tspan>
      </text>
    </g>
  </Svg>
)

ExtraPrincipalTeaserScreen.propTypes = propTypes

export default ExtraPrincipalTeaserScreen
